import Resource from '@/services/resources/common';

export default class PartnerTypeResource extends Resource {
  constructor(entrypoint = '/partner_types', alias = 'PartnerType') {
    super(entrypoint, alias);
  }
}
